import { useQuery } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';

export const useGetCorrupted = () => {
  const { data: corrupted, isLoading: isLoadingCorrupted } = useQuery<any[]>({
    queryKey: ['system/sync/corrupted'],
    queryFn: () => customFetcher({ endpoint: '/system/sync/corrupted' }),
  });

  return { corrupted, isLoadingCorrupted };
};

export const useGetStateObject = () => {
  const { data: stateObject, isLoading: isLoadingStateObject } = useQuery<{
    State: string;
  }>({
    queryKey: ['system/sync/state'],
    queryFn: () => customFetcher({ endpoint: '/system/sync/state' }),
  });

  return { stateObject, isLoadingStateObject };
};
